import React, { useState } from 'react';

const MobileDropdown = ({ onSearch, onNavigate, currentMatch, totalMatches, timelineData }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSearch = (e) => {
    onSearch(e.target.value);
  };

  const handlePrevious = () => {
    if (onNavigate) onNavigate('previous');
  };

  const handleNext = () => {
    if (onNavigate) onNavigate('next');
  };

  return (
    <div className="mobile-dropdown-container">
      <button 
        className="mobile-dropdown-toggle"
        onClick={toggleDropdown}
        aria-label="Open menu"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
        </svg>
      </button>
      
      {isOpen && (
        <div className="mobile-dropdown-menu">
          <div className="mobile-dropdown-header">
            <h3>Menu</h3>
            <button 
              className="mobile-dropdown-close"
              onClick={toggleDropdown}
              aria-label="Close menu"
            >
              ×
            </button>
          </div>
          
          <div className="mobile-dropdown-content">
            <div className="mobile-search-section">
              <label htmlFor="mobile-search">Search Timeline</label>
              <input
                id="mobile-search"
                type="text"
                placeholder="Search timeline..."
                onChange={handleSearch}
                className="mobile-search-input"
              />
              {totalMatches > 0 && (
                <div className="mobile-search-navigation">
                  <span className="mobile-match-count">
                    {currentMatch} of {totalMatches}
                  </span>
                  <div className="mobile-nav-buttons">
                    <button 
                      onClick={handlePrevious} 
                      className="mobile-nav-button"
                      disabled={currentMatch <= 1}
                    >
                      ↑
                    </button>
                    <button 
                      onClick={handleNext} 
                      className="mobile-nav-button"
                      disabled={currentMatch >= totalMatches}
                    >
                      ↓
                    </button>
                  </div>
                </div>
              )}
            </div>
            
            <div className="mobile-download-section">
              <button 
                className="mobile-download-button"
                onClick={() => {
                  // Trigger download functionality
                  const downloadEvent = new CustomEvent('downloadRequested', { detail: timelineData });
                  window.dispatchEvent(downloadEvent);
                  setIsOpen(false);
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                </svg>
                Download Data
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileDropdown;
